import { useTableActionContext } from '@aibees/elephant/context';
import { useActionSearchType } from '@aibees/elephant/hooks';
import { RHFCheckbox } from '@aibees/shared/components';
import { ACCORDION_IDS } from '@aibees/shared/store';
import { classnames } from '@aibees/shared/utils';
import { useWorkspaceUsers } from '@aibees/shared/workspace';
import { Box } from '@mui/material';
import { memo } from 'react';
import { InformNotificationPopup } from '../inform-notification-popup';
import { OwnerSelect } from '../owner-select';
import * as Styled from './styles';
import * as SX from './sx';
import type { AssignOwnerProps as Props } from './types';

export const AssignOwner = memo(
  ({ className, state, expandedAccordion, setExpandedAccordion }: Props) => {
    const { ids: _ids, selectedOwner } = useTableActionContext();
    const users = useWorkspaceUsers(true);
    const selectedUser = users.find((user) =>
      selectedOwner ? user.id === selectedOwner : user.current
    );
    const tags = `${selectedUser?.firstName} ${selectedUser?.lastName} ${
      selectedUser?.current ? `(You)` : ``
    }`;
    const { isPeople } = useActionSearchType();

    return (
      <Styled.Wrapper
        id={ACCORDION_IDS.ASSIGN_OWNER}
        className={classnames('AssignOwner', className)}
        sx={SX.root}
        state={state}
        title={`Assign ${isPeople ? 'Contact' : 'Account'} Owner`}
        leftIcon="account-tag"
        description={tags}
        expandedAccordion={expandedAccordion}
        setExpandedAccordion={setExpandedAccordion}
      >
        <OwnerSelect />

        <Box sx={SX.row}>
          <RHFCheckbox
            name="overwriteOwner"
            label="Set and overwrite owner for all records."
            sx={SX.checkbox}
            size="small"
          />

          <InformNotificationPopup>
            Assign ownership to all selected people. OVERWRITE ownership of
            existing, saved people.
          </InformNotificationPopup>
        </Box>
      </Styled.Wrapper>
    );
  }
);

AssignOwner.displayName = 'AssignOwner';
